import { lazy } from "react";

export const routes = {
  restricted: {
    path: "/",
    element: lazy(() => import("../../pages/Restricted")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  residentElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
} as const;
